import type { ChatDocument, ChatMessageDocument } from '@models/chat';
import { useQuery } from '@tanstack/react-query';
import { getPublicUserDoc } from '@util/firestore/users';
import { useCancellationRequests } from 'app/support/hooks/useCancellationRequests';
import RequestMessage from './RequestMessage';
import { getOrderNumFromContent } from './utils';

interface CancellationsMessageProps {
  message: ChatMessageDocument;
  chat: ChatDocument;
}

export default function CancellationsMessage({
  message,
  chat,
}: CancellationsMessageProps) {
  const {
    data: { data: cancellations, isLoading },
  } = useCancellationRequests({
    order_id: chat.order_id,
    seller_id: chat.seller_id,
  });

  const { data: seller } = useQuery({
    queryKey: ['publicUser', chat.seller_id],
    queryFn: () => getPublicUserDoc({ uid: chat.seller_id }),
    enabled: !!chat.seller_id,
  });

  const cancellation = cancellations?.[0] ?? null;
  const reason = cancellation?.reason ?? null;

  const orderNumFromContent = getOrderNumFromContent(message.content);

  const sellerName = seller?.username ?? 'there';
  const bodyText = `Hello ${sellerName}, the customer has requested to cancel this order due to the following reason. Please let us know how you'd like to proceed. Your account will not be affected by cancelling this order.`;

  return (
    <RequestMessage
      message={message}
      chat={chat}
      label="Cancellation Request"
      reason={reason}
      bodyText={bodyText}
      isLoading={isLoading}
      orderNumFallback={orderNumFromContent}
    />
  );
}
